import { useAuth } from "hooks‬/Auth";
import apiInterceptor from "services/apiInterceptor";
import { authApiEndpoint } from "constant/apiConstants";
import { useSearchParams } from "react-router-dom";
import { localLogout } from "helpers/utils";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const EmailNotVerified = () => {
  const { systemLogout } = useAuth();
  const { t } = useTranslation();
  const loginPageRedirector = () => {
    systemLogout();
  };
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const [countdown, setCountdown] = useState<number>(0);
  const [isSentEmail, setIsSentEmail] = useState(false);
  const [isSubmiting, setIsSubmiting] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);

  const resendEmailVerification = () => {
    localLogout();
    setIsSubmiting(true);
    apiInterceptor
      .put(authApiEndpoint.EMAIL_VERIFICATION, {
        email: email,
      })
      .then((response) => {
        if (response.status === 200) {
          setCountdown(10);
          setIsSentEmail(true);
          setTimeout(() => {
            loginPageRedirector();
          }, 10000);
        } else {
          console.error("Failed to send verification email.");
        }
      })
      .catch((error) => {
        console.error("Error sending verification email:", error);
      });
  };

  return (
    <div className="m-auto mt-10">
      {isSentEmail ? (
        <>
          <div
            style={{ fontSize: "32px" }}
            className="text-center fw-bold mt-5"
          >
            {t("messages:VERIFY.EMAIL")}
          </div>
          <div className="text-gray-700 text-center fw-semibold fs-4">
            {t("messages:HAVE.SENT.AN.EMAIL")}{" "}
            <span className="text-primary fw-bold">{email}</span> <br />
            {t("messages:VERIFY.YOUR.EMAIL.ADDRESS")}
          </div>
        </>
      ) : (
        <>
          <div
            style={{ fontSize: "32px" }}
            className="text-center fw-bold mt-5"
          >
            Email verification required
          </div>
          <div className="text-gray-700 text-center fw-semibold fs-4">
            We’ve sent a verification link to:{" "}
            <span className="text-primary fw-bold">{email}</span>
            <br />
            Please check your inbox and click the link to activate your account.
          </div>
        </>
      )}

      <div className="text-center mt-15">
        <button
          className="btn btn-primary w-lg-500px w-sm-500px w-100"
          onClick={resendEmailVerification}
          disabled={isSubmiting}
        >
          {isSentEmail
            ? `Redirecting to login in ${countdown}  seconds`
            : "Resend Email"}
        </button>
      </div>
      <div className="text-center text-gray-700 fs-3 mt-5">
        Email verified?{" "}
        <button
          onClick={systemLogout}
          className="text-link bg-transparent border-0 fs-3   btn-none btn-hover-success link"
        >
          Login
        </button>
      </div>
    </div>
  );
};

export default EmailNotVerified;
